// Date helpers shared across the SemakLesen feature.

// Returns the number of days between today and the expiry date string in DD/MM/YYYY format.
// Positive = days remaining, negative = days since expiry.
export const getDaysFromExpiry = (expiryDateStr) => {
  if (!expiryDateStr) return 0;
  const [d, m, y] = expiryDateStr.split('/');
  const expiry = new Date(`${y}-${m}-${d}`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((expiry - today) / (1000 * 60 * 60 * 24));
};
